import * as logger from '@mamdev/navigator.frontend-logger'
import { getLoginUrls } from './util/login-urls'
import { getBrand } from './util/brand'

const FORM_EL_ID = 'login'

export function showForm(): void {
  const form = document.getElementById(FORM_EL_ID) as HTMLFormElement
  form.style.display = 'block'
}

export function initForm(accessToken: string) {
  const loginUrls = getLoginUrls()
  const form = document.getElementById(FORM_EL_ID) as HTMLFormElement
  form.action = loginUrls.loginServiceUrl;

  form.querySelector<HTMLInputElement>('#service').value = getBrand() === 'gmx.net' ? 'partnershopgmx' : 'partnershopwebde';
  form.querySelector<HTMLInputElement>('#successUrl').value = loginUrls.successUrl;
  form.querySelector<HTMLInputElement>('#loginFailedUrl').value = loginUrls.loginFailedUrl;
  form.querySelector<HTMLInputElement>('#loginErrorUrl').value = loginUrls.loginErrorUrl;
  form.querySelector<HTMLInputElement>('#accessToken').value = accessToken;
}

export function submitForm() {
  const form = document.getElementById(FORM_EL_ID) as HTMLFormElement
  form.submit()
}

export function login(accessToken: string) {
  logger.debug('Logging into shop...')

  initForm(accessToken)
  submitForm()
}
